import React from 'react'
import { Box, TextField, Typography,Grid,Slider } from '@mui/material';
import useEmailEditorStore from '../../utilities/emailEditorStore';
import { AlignHorizontalLeft, AlignHorizontalRight, AlignVerticalBottom, AlignVerticalTop,Height } from '@mui/icons-material';

function DividerBlockProperties({blockId}) {
   const { getBlockById, updateBlockProperties } = useEmailEditorStore();
  
  // Get the current block data from the store
  const block = getBlockById(blockId);
  
  if (!block) {
    return <Typography>Block not found</Typography>;
  }
  
  // Provide default properties if properties is undefined
  const properties = block.properties || {};

  // Generic property change handler
  const handlePropertyChange = (propertyName, value) => {
    updateBlockProperties(blockId, { [propertyName]: value });
  };
    // Specific handler for margin changes
  const handleMarginChange = (side, value) => {
    const currentMargin = properties.margin || { top: 0, right: 0, bottom: 0, left: 0 };
    const newMargin = { ...currentMargin, [side]: parseInt(value) || 0 };
    handlePropertyChange('margin', newMargin);
  };
  return (
    <>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
             <Box>
                              <Typography variant="body2" gutterBottom>
                                                    Height
                                                  </Typography>
                                                  <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                                                    <Grid>
                                                     <Height/>
                                                    </Grid>
                                                    <Grid size="grow">
                                                      <Slider
                                                        value={properties.height || 1}
                                                        onChange={(e, value) => handlePropertyChange('height', value)}
                                                        aria-labelledby="input-slider-height"
                                                        step={1}
                                                        marks
                                                        max={25}
                                                      />
                                                    </Grid>
                                                    <Grid>
                                                      <Typography variant="body2" gutterBottom>
                                                        {properties.height || 16} px
                                                      </Typography>
                                                    </Grid>
                                                  </Grid>
                                                </Box>
            <TextField
              fullWidth
              label="Width"
              value={properties.width || '100%'}
              onChange={(e) => handlePropertyChange('width', e.target.value)}
              sx={{ mb: 2 }}
            />

            
          
            <Box>
                <Typography variant="body2" sx={{ mb: 1, fontWeight: 400 }}>
                        Color
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                          <input
                            type="color"
                            value={properties.dividerbackgroundColor || '#000000'}
                            onChange={(e) => handlePropertyChange('dividerbackgroundColor', e.target.value)}
                            style={{
                              width: 40,
                              height: 40,
                              border: '1px solid #ccc',
                              borderRadius: 4,
                              cursor: 'pointer'
                            }}
                          />
                          <TextField
                            value={properties.dividerbackgroundColor || '#000000'}
                            onChange={(e) => handlePropertyChange('dividerbackgroundColor', e.target.value)}
                            size="small"
                            variant="outlined"
                            sx={{ flexGrow: 1 }}
                          />
                        </Box>
              </Box>
               {/* Margin */}
          <Box>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 400 }}>
              Margin
            </Typography>
            <Grid container spacing={2} sx={{ alignItems: 'center' }}>
              <Grid>
                <AlignVerticalTop />
              </Grid>
              <Grid size="grow">
                <Slider
                  value={properties.margin?.top || 0}
                  onChange={(e, value) => handleMarginChange('top', value)}
                  aria-labelledby="input-slider-margin-top"
                  step={1}
                  marks
                  max={80}
                  min={0}
                />
              </Grid>
              <Grid>
                <Typography variant="body2" gutterBottom>
                  {properties.margin?.top || 0} px
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ alignItems: 'center' }}>
              <Grid>
                <AlignHorizontalRight />
              </Grid>
              <Grid size="grow">
                <Slider
                  value={properties.margin?.right || 0}
                  onChange={(e, value) => handleMarginChange('right', value)}
                  aria-labelledby="input-slider-margin-right"
                  step={1}
                  marks
                  max={80}
                  min={0}
                />
              </Grid>
              <Grid>
                <Typography variant="body2" gutterBottom>
                  {properties.margin?.right || 0} px
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ alignItems: 'center' }}>
              <Grid>
                <AlignVerticalBottom />
              </Grid>
              <Grid size="grow">
                <Slider
                  value={properties.margin?.bottom || 0}
                  onChange={(e, value) => handleMarginChange('bottom', value)}
                  aria-labelledby="input-slider-margin-bottom"
                  step={1}
                  marks
                  max={80}
                  min={0}
                />
              </Grid>
              <Grid>
                <Typography variant="body2" gutterBottom>
                  {properties.margin?.bottom || 0} px
                </Typography>
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ alignItems: 'center' }}>
              <Grid>
                <AlignHorizontalLeft />
              </Grid>
              <Grid size="grow">
                <Slider
                  value={properties.margin?.left || 0}
                  onChange={(e, value) => handleMarginChange('left', value)}
                  aria-labelledby="input-slider-margin-left"
                  step={1}
                  marks
                  max={80}
                  min={0}
                />
              </Grid>
              <Grid>
                <Typography variant="body2" gutterBottom>
                  {properties.margin?.left || 0} px
                </Typography>
              </Grid>
            </Grid>
          </Box>
          </Box>
          </>
  )
}

export default DividerBlockProperties